export default {
  ghostSection(section) {
    // If already un-ghosted, dont ghost again
    if (section.ghost === false && section.hidden === false) { return; }
    const sec = section;
    sec.hidden = false;
    sec.ghost = true;
  },
  showSection(section) {
    const sec = section;
    sec.hidden = false;
    sec.ghost = false;
  },
  workStatement(employmentStatus) {
    const nonWorking = ['on a career break', 'not working due to a long term illness', 'Retired'];
    const matLeave = 'on maternity leave';
    const nonWorkingText = nonWorking.find((status) => status === employmentStatus)
      ? 'I worked as a'
      : 'I work as a';

    return employmentStatus === matLeave
      ? 'Before going on maternity leave, I worked as a '
      : nonWorkingText;
  },
};
